// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as GraphqlTag from "graphql-tag";
import * as SpaceX$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/SpaceX.res.mjs";
import * as QueryHook2$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/QueryHook2.res.mjs";
import * as Tz$LiteracyplanetSharedClientProfile from "@literacyplanet/shared-client-profile/src/Tz.res.mjs";
import * as HasuraTypes$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/HasuraTypes.res.mjs";
import * as UserContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/UserContext.res.mjs";
import * as FlagsContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/FlagsContext.res.mjs";
import * as BadgesContext$LiteracyplanetClientSxEntry from "./BadgesContext.res.mjs";
import * as BadgeTypes$LiteracyplanetSharedClientProfile from "@literacyplanet/shared-client-profile/src/BadgeTypes.res.mjs";
import * as RequestTrophyDataMutation$LiteracyplanetClientSxEntry from "./RequestTrophyDataMutation.res.mjs";

function useAwardArcadeBadges() {
  var hasFlag = FlagsContext$LiteracyplanetClientFlags.use();
  var user = UserContext$LiteracyplanetClientFlags.use();
  var userId = user.userId;
  var match = BadgesContext$LiteracyplanetClientSxEntry.use();
  var awardBadges = match.awardBadges;
  var getBadges = match.getBadges;
  return async function (badgeId) {
    if (!hasFlag("FeatBadges")) {
      return ;
    }
    var badges = await getBadges(userId);
    var input = [{
        TAG: "ArcadeAchievement",
        code: badgeId
      }];
    var awards = BadgeTypes$LiteracyplanetSharedClientProfile.testAwards(badges, input);
    return await awardBadges(awards, userId);
  };
}

var Raw = {};

var query = GraphqlTag.gql(["query ActivityAggQuery($userId: uuid!, $userIdStr: ID!)  {\ntrophies(where: {userId: {_eq: $userId}})  {\n__typename  \nsource  \ngold  \n}\n\ncountCompleteAssignedStudentMissions(userId: $userIdStr)  \nhighFives: high_fives_by_pk(userId: $userId)  {\n__typename  \ngiven  \n}\n\nthumbsUp: thumbs_up_by_pk(userId: $userId)  {\n__typename  \ngiven  \n}\n\npublicStudentProfile(nextUuid: $userIdStr)  {\n__typename  \ngems  \n}\n\n}\n"]);

function parse(value) {
  var value$1 = value.trophies;
  var value$2 = value.highFives;
  var value$3 = value.thumbsUp;
  var value$4 = value.publicStudentProfile;
  return {
          trophies: value$1.map(function (value) {
                return {
                        __typename: value.__typename,
                        source: value.source,
                        gold: value.gold
                      };
              }),
          countCompleteAssignedStudentMissions: value.countCompleteAssignedStudentMissions,
          highFives: !(value$2 == null) ? ({
                __typename: value$2.__typename,
                given: value$2.given
              }) : undefined,
          thumbsUp: !(value$3 == null) ? ({
                __typename: value$3.__typename,
                given: value$3.given
              }) : undefined,
          publicStudentProfile: {
            __typename: value$4.__typename,
            gems: value$4.gems
          }
        };
}

function serialize(value) {
  var value$1 = value.publicStudentProfile;
  var value$2 = value$1.gems;
  var value$3 = value$1.__typename;
  var publicStudentProfile = {
    __typename: value$3,
    gems: value$2
  };
  var value$4 = value.thumbsUp;
  var thumbsUp;
  if (value$4 !== undefined) {
    var value$5 = value$4.given;
    var value$6 = value$4.__typename;
    thumbsUp = {
      __typename: value$6,
      given: value$5
    };
  } else {
    thumbsUp = null;
  }
  var value$7 = value.highFives;
  var highFives;
  if (value$7 !== undefined) {
    var value$8 = value$7.given;
    var value$9 = value$7.__typename;
    highFives = {
      __typename: value$9,
      given: value$8
    };
  } else {
    highFives = null;
  }
  var value$10 = value.countCompleteAssignedStudentMissions;
  var value$11 = value.trophies;
  var trophies = value$11.map(function (value) {
        var value$1 = value.gold;
        var value$2 = value.source;
        var value$3 = value.__typename;
        return {
                __typename: value$3,
                source: value$2,
                gold: value$1
              };
      });
  return {
          trophies: trophies,
          countCompleteAssignedStudentMissions: value$10,
          highFives: highFives,
          thumbsUp: thumbsUp,
          publicStudentProfile: publicStudentProfile
        };
}

function serializeVariables(inp) {
  return {
          userId: inp.userId,
          userIdStr: inp.userIdStr
        };
}

function makeVariables(userId, userIdStr, param) {
  return {
          userId: userId,
          userIdStr: userIdStr
        };
}

var ActivityAggregateQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

var include = SpaceX$LiteracyplanetClientFlags.Query.Extend({
      query: query,
      Raw: Raw,
      parse: parse,
      serialize: serialize,
      serializeVariables: serializeVariables
    });

var use = include.use;

var useFetch = include.useFetch;

var ActivityAggregateQuery = {
  ActivityAggregateQuery_inner: ActivityAggregateQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  use: use,
  useFetch: useFetch
};

var AQ = QueryHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw,
      use: use,
      useFetch: useFetch
    });

function makeTrophyBadgeAward(source, gold) {
  return {
          TAG: "TrophyCount",
          source: source,
          gold: gold
        };
}

function useBuildTrophyCache() {
  var user = UserContext$LiteracyplanetClientFlags.use();
  var userId = user.userId;
  var hasFlag = FlagsContext$LiteracyplanetClientFlags.use();
  var requestTrophyData = RequestTrophyDataMutation$LiteracyplanetClientSxEntry.use();
  return async function (res) {
    if (res.trophies.length === 0) {
      if (hasFlag("FeatBuildTrophyCache")) {
        return Belt_Array.map(await requestTrophyData(userId), (function (param) {
                      return {
                              TAG: "TrophyCount",
                              source: param.source,
                              gold: param.gold
                            };
                    }));
      } else {
        return [];
      }
    } else {
      return Belt_Array.map(res.trophies, (function (param) {
                    return {
                            TAG: "TrophyCount",
                            source: param.source,
                            gold: param.gold
                          };
                  }));
    }
  };
}

function makeMisisonCompleteBadgeAwards(res) {
  if (res.countCompleteAssignedStudentMissions > 0) {
    return [{
              TAG: "MissionCompleteCount",
              source: "STUDENT_MISSIONS",
              count: res.countCompleteAssignedStudentMissions
            }];
  } else {
    return [];
  }
}

function makeHighFiveBadgeAwards(res) {
  return Belt_Option.mapWithDefault(res.highFives, [], (function (param) {
                return [{
                          TAG: "HighFivesAchievement",
                          given: param.given + 1 | 0
                        }];
              }));
}

function makeThumbsUpBadgeAwards(res) {
  return Belt_Option.mapWithDefault(res.thumbsUp, [], (function (param) {
                return [{
                          TAG: "ThumbsUpAchievement",
                          given: param.given + 1 | 0
                        }];
              }));
}

function makeGemBadgeAwards(res) {
  if (res.publicStudentProfile.gems > 0) {
    return [{
              TAG: "GemsSaved",
              gems: res.publicStudentProfile.gems
            }];
  } else {
    return [];
  }
}

function useFetchActivity(userId) {
  var hasFlag = FlagsContext$LiteracyplanetClientFlags.use();
  var fetchActivity = AQ.useAsync();
  var buildTrophyCache = useBuildTrophyCache();
  return async function () {
    if (!hasFlag("FeatBadges")) {
      return [];
    }
    var zone = Tz$LiteracyplanetSharedClientProfile.getUsersTimeZone();
    var res = await fetchActivity({
          userId: HasuraTypes$LiteracyplanetClientFlags.encode(userId),
          userIdStr: userId
        });
    if (res !== undefined) {
      return Belt_Array.concatMany([
                  await buildTrophyCache(res),
                  makeMisisonCompleteBadgeAwards(res),
                  makeHighFiveBadgeAwards(res),
                  makeThumbsUpBadgeAwards(res),
                  makeGemBadgeAwards(res),
                  [{
                      TAG: "DateAchievement",
                      isToday: Tz$LiteracyplanetSharedClientProfile.makeDateCompareFn(zone)
                    }]
                ]);
    } else {
      return [];
    }
  };
}

function useAwardActivityBadges() {
  var hasFlag = FlagsContext$LiteracyplanetClientFlags.use();
  var user = UserContext$LiteracyplanetClientFlags.use();
  var userId = user.userId;
  var match = BadgesContext$LiteracyplanetClientSxEntry.use();
  var awardBadges = match.awardBadges;
  var getBadges = match.getBadges;
  var fetchActivityAwards = useFetchActivity(userId);
  return async function () {
    if (!hasFlag("FeatBadges")) {
      return ;
    }
    var testActivityAwards = await fetchActivityAwards();
    var badges = await getBadges(userId);
    var awards = BadgeTypes$LiteracyplanetSharedClientProfile.testAwards(badges, testActivityAwards);
    await awardBadges(awards, userId);
  };
}

export {
  useAwardArcadeBadges ,
  ActivityAggregateQuery ,
  AQ ,
  makeTrophyBadgeAward ,
  useBuildTrophyCache ,
  makeMisisonCompleteBadgeAwards ,
  makeHighFiveBadgeAwards ,
  makeThumbsUpBadgeAwards ,
  makeGemBadgeAwards ,
  useFetchActivity ,
  useAwardActivityBadges ,
}
/* query Not a pure module */
